import { Button } from "@loot-os/design-system/core/Button";
import { Text } from "@loot-os/design-system/core/Text";
import * as Sentry from "@sentry/react";
import { type ErrorComponentProps, useRouter } from "@tanstack/react-router";
import { useEffect } from "react";

import { reloadIfBuildReplaced } from "../lib/staleBuild.js";

/**
 * The router's default errorComponent: reports the render failure and offers one retry. A page
 * whose chunk is gone because a deploy replaced this tab's build reloads onto the current one
 * (the router reloads for a missing module itself, but not for a missing stylesheet).
 */
export function RouteError({ error }: ErrorComponentProps) {
  const router = useRouter();
  useEffect(() => {
    Sentry.captureException(error);
    void reloadIfBuildReplaced(error);
  }, [error]);
  return (
    <div className="py-16 text-center">
      <Text as="h1" variant="heading-h1" tone="primary">
        Something went wrong
      </Text>
      <div className="mt-4">
        <Button onClick={() => router.invalidate()}>Try again</Button>
      </div>
    </div>
  );
}
